import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Send, Mail } from 'lucide-react';
import { siteContent, contactInfo } from './data';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-cyan-900/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-green-500 rounded-lg flex items-center justify-center shadow-lg shadow-cyan-500/25">
                <Shield className="w-6 h-6 text-black" />
              </div>
              <span className="text-xl font-bold text-white">{siteContent.footer.company}</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-md">
              {siteContent.footer.tagline}. Protecting your digital assets with advanced anti-phishing detection, DMCA enforcement, and comprehensive brand protection solutions.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href={contactInfo.telegram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
                aria-label="Telegram"
              >
                <Send className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.email}
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{siteContent.footer.quickLinks}</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
                >
                  {siteContent.nav.home}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
                >
                  {siteContent.nav.services}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
                >
                  {siteContent.nav.about}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
                >
                  {siteContent.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">{siteContent.footer.services}</h3>
            <ul className="space-y-2">
              {siteContent.services.items.map((service, index) => (
                <li key={index}>
                  <Link
                    to="/services"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="text-gray-400 hover:text-cyan-400 text-sm transition-colors duration-300"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-cyan-900/30">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} {siteContent.footer.company}. {siteContent.footer.rights}.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <a
                href={contactInfo.telegram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
              >
                {contactInfo.telegramHandle}
              </a>
              <span className="text-gray-600">|</span>
              <a
                href={contactInfo.email}
                className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
              >
                {contactInfo.emailDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;